import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full h-[200px] overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          {article.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span>{article.date}</span>
          <span>{article.readTime}阅读</span>
        </div>
      </div>
    </Link>
  );
}